declare global {
  interface Window {
    aplus_queue?: Array<{ action: string; arguments: unknown[] }>
  }
}

export function sendUmengEvent(eventName: string, params: Record<string, string | number>) {
  if (!window.aplus_queue) {
    console.warn('aplus_queue not initialized')
    return
  }

  window.aplus_queue.push({
    action: 'aplus.record',
    arguments: [eventName, 'CLK', params]
  })
}
